export default __webpack_public_path__ + "static/PES-mobile-2-7c407838b310edd7a789f6eccafdb71c.jpg";